module.exports = __webpack_public_path__ + "img/picto-dossier-bl.042cafbc.svg";